import { render, staticRenderFns } from "./UserViewDialog.vue?vue&type=template&id=4167959c&scoped=true"
import script from "./UserViewDialog.vue?vue&type=script&lang=js"
export * from "./UserViewDialog.vue?vue&type=script&lang=js"
import style0 from "./UserViewDialog.vue?vue&type=style&index=0&id=4167959c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4167959c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4167959c')) {
      api.createRecord('4167959c', component.options)
    } else {
      api.reload('4167959c', component.options)
    }
    module.hot.accept("./UserViewDialog.vue?vue&type=template&id=4167959c&scoped=true", function () {
      api.rerender('4167959c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/customComponent/UserViewDialog.vue"
export default component.exports